module.exports = __webpack_public_path__ + "static/media/login_image.1cbf0b5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/login_image.jpg
// module id = 160
// module chunks = 0